export const styles: {
    container: React.CSSProperties,
    input: React.CSSProperties,
    message: React.CSSProperties,
    messageSuccess: React.CSSProperties,
    messageError: React.CSSProperties,
  } = {
    container: {
      position: 'relative',
      display: "flex",
      verticalAlign: "middle",
      alignItems: "center",
      borderRadius: "5px",
      borderStyle: "dashed",
      flexDirection: "column",
      justifyContent: "center",
      outline: "none",
      fontFamily: "Nunito Sans, Helvetica Neue, helvetica, arial, sans-serif"
    },
    input: {
      position: 'absolute',
      left: '0',
      top: '0',
      width: '1px',
      height: '1px',
      opacity: '0',
      cursor: 'default',
    },
    message: {
      position: 'absolute',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      width: '100%',
      height: '100%',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexFlow: 'column nowrap',
      fontFamily: 'Tahoma, sans-serif',
      opacity: '1',
      textAlign: 'center',
    },
    messageSuccess: {
      backgroundColor: '#e7f7e7',
      color: '#8ecf99',
    },
    messageError: {
      backgroundColor: '#f7e7e7',
      color: '#cf8e99',
    },
  };